/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_History_NoneInputs */



/**
* | output |
* | --- |
* | "No conversation info yet" |
*
* @param {Team_History_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_history_none = /** @type {((inputs?: Team_History_NoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_History_NoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gespreksinfo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore d'infos d'entretien")
	return /** @type {LocalizedString} */ ("No conversation info yet")
});